import React from 'react';
import ProductPricing from 'shared/components/commerce/ProductPricing';
import { DisplayPrice, VariantPrice } from '../../../../../Roc.SharedClientApp/types/commerce/display-price';
import { PricingLine } from '../../../../../Roc.SharedClientApp/types/commerce/pricing-result';
import { GetPriceForQuantity } from '../pricing/pricing-result';

export interface ProductPriceListProps {
	pricingLine: PricingLine<DisplayPrice<VariantPrice, VariantPrice>>;
	quantity: number;
}

function ProductPriceList(props: ProductPriceListProps) {
	const { pricingLine, quantity } = props;

	let price: DisplayPrice<VariantPrice, VariantPrice> | null = null;
	try {
		price = GetPriceForQuantity(pricingLine.prices, quantity);
	} catch (error) {
		price = null;
	}

	return price == null ? (
		<span>N/A</span>
	) : (
		<ProductPricing
			displayPrice={price}
			className="roc-options-table__text roc-options-table__text--right"
			inline
			testId="pdp-main-price"
		/>
	);
}

export default ProductPriceList;
